import { useTranslation } from "react-i18next";

import FullPageMessage from "../FullPageMessage";

function SignUpSuccessfully() {
  const LocalBasePath = "page.signUpSuccessfully";
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });
  return <FullPageMessage body={t("reviewMessage")} title={t("signDone")} />;
}
export default SignUpSuccessfully;
